import '../stylesheets/application.scss';
import '../stylesheets/devise.scss';

require('bootstrap');
